import React from 'react';
import { Link } from 'react-router-dom';
import SiteLogo, { SiteLogoVariant } from './SiteLogo';

export const SITE_BRAND_TAGLINE = 'Connecting Tech Talent';

type SiteBrandProps = {
  markSize?: number;
  showWordmark?: boolean;
  showTagline?: boolean;
  layout?: 'horizontal' | 'stacked';
  to?: string;
  className?: string;
  wordmarkClassName?: string;
  markClassName?: string;
  variant?: SiteLogoVariant;
  onClick?: () => void;
};

const SiteBrand: React.FC<SiteBrandProps> = ({
  markSize = 40,
  showWordmark = true,
  showTagline = true,
  layout = 'horizontal',
  to,
  className = '',
  wordmarkClassName = 'jo-wordmark text-base font-black uppercase leading-tight tracking-tight',
  markClassName = '',
  variant = 'default',
  onClick,
}) => {
  const layoutClass =
    layout === 'stacked'
      ? 'flex flex-col items-start gap-2'
      : 'flex items-center gap-3';

  const content = (
    <>
      <SiteLogo
        size={markSize}
        className={`site-brand-mark ${markClassName}`.trim()}
        variant={variant}
      />
      {showWordmark && (
        <span className={`site-brand-wordmark ${wordmarkClassName}`.trim()}>
          <span className="site-brand-wordmark-title">
            Jobs <span className="site-brand-wordmark-amp">&</span>{' '}
            Opportunities
          </span>
          {showTagline ? (
            <span className="site-brand-tagline">{SITE_BRAND_TAGLINE}</span>
          ) : null}
        </span>
      )}
    </>
  );

  const interactiveClass = `${layoutClass} ${className} jo-link`.trim();
  const ariaLabel = showTagline
    ? 'Jobs and Opportunities — Connecting Tech Talent — home'
    : 'Jobs and Opportunities home';

  if (to) {
    return (
      <Link
        to={to}
        className={interactiveClass}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {content}
      </Link>
    );
  }

  return <div className={`${layoutClass} ${className}`.trim()}>{content}</div>;
};

export default SiteBrand;
